import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useAuthStore } from '../stores/auth'
import { usePermissions, type PermissionsType } from '@/stores/permissions'
import { isEmbeddedInBackend } from '@/lib/parentPostMessage'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { requiresAuth: true }
    },
    {
      path: '/chats',
      name: 'ChatsView',
      component: () => import('@/views/ChatsView.vue'),
      meta: {
        layout: 'DashboardLayout',
        requiresAuth: true
        // permission: 'canValidateManualCreatedPolicies'
      },
      beforeEnter: [removeQueryParams]
    },
    {
      path: '/buscador',
      name: 'SearchEnsuredView',
      component: () => import('@/views/SearchEnsuredView.vue'),
      meta: { layout: 'DashboardLayout', requiresAuth: true }
    },
    {
      path: '/resultados/asegurados',
      name: 'SearchPolicyholderResultsView',
      component: () => import('@/views/SearchPolicyholderResultsView.vue'),
      meta: { layout: 'DashboardLayout', requiresAuth: true }
    },
    {
      path: '/resultados/pedido',
      name: 'SearchRequestResultView',
      component: () => import('@/views/SearchRequestResultView.vue'),
      meta: { layout: 'DashboardLayout', requiresAuth: true }
    },
    {
      path: '/tareas',
      name: 'TasksView',
      component: () => import('@/views/TasksView.vue'),
      meta: {
        layout: 'DashboardLayout',
        requiresAuth: true
        // permission: 'canValidateManualCreatedPolicies'
      },
      beforeEnter: [removeQueryParams]
    },
    {
      path: '/pedido/:requestId',
      name: 'RequestDetailView',
      component: () => import('@/views/RequestDetailView.vue'),
      meta: { title: 'Detalle del pedido', layout: 'DashboardLayout', requiresAuth: true }
    },
    {
      path: '/cliente/:clientId',
      name: 'PolicyholderProfileView',
      component: () => import('@/views/PolicyholderProfileView.vue'),
      meta: { title: 'Detalle del cliente', layout: 'DashboardLayout', requiresAuth: true },
      props: true
    },
    {
      path: '/supervision',
      meta: { layout: 'DashboardLayout', requiresAuth: true },
      children: [
        {
          path: 'tareas',
          name: 'SupervisionTaskView',
          component: () => import('@/views/SupervisionTaskView.vue')
        },
        {
          path: 'chats',
          name: 'SupervisionChatView',
          component: () => import('@/views/SupervisionChatView.vue')
        },
        {
          path: 'editar-equipo',
          name: 'SupervisionEditTeamView',
          component: () => import('@/views/SupervisionEditTeamView.vue')
        },
        {
          path: 'editar-equipo/operador/:operator/cola/:queue/teamId/:teamId',
          name: 'SupervisionEditOperatorView',
          props: true,
          component: () => import('@/views/SupervisionEditOperatorView.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/error/:resource',
      name: 'ErrorBoundary',
      props: true,
      component: () => import('@/views/ErrorView.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const permissionsStore = usePermissions()
  const tokenFromQuery = typeof to.query.token === 'string' ? to.query.token : undefined

  // En iframe, el token del parent es la fuente de verdad: siempre re-autenticar
  if (to.meta.requiresAuth && tokenFromQuery && isEmbeddedInBackend()) {
    return next({
      path: '/login',
      query: {
        token: tokenFromQuery,
        redirect: to.path
      }
    })
  }

  if (to.meta.requiresAuth && !authStore.user) {
    return next({
      path: '/login',
      query: {
        token: to.query.token,
        redirect: to.fullPath
      }
    })
  }
  const requiredPermission = to.meta.permission
  if (
    requiredPermission &&
    !permissionsStore.userPermissions[requiredPermission as PermissionsType]
  ) {
    return next({ name: 'SearchEnsuredView' })
  }
  next()
})

// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore()
//   const permissionsStore = usePermissions()

//   if (to.matched.some((r) => r.meta.requiresAuth)) {
//     if (!authStore.user) {
//       return next({
//         path: '/login',
//         query: {
//           token: to.query.token,
//           redirect: to.fullPath
//         }
//       })
//     }
//   }

//   const requiredPermission = to.meta.permission as PermissionsType | undefined

//   if (requiredPermission) {
//     const hasPermission = permissionsStore.userPermissions[requiredPermission]

//     if (!hasPermission) {
//       return next({ name: 'home' })
//     }
//   }

//   next()
// })

function removeQueryParams(to: RouteLocationNormalized) {
  if (Object.keys(to.query).length) return { path: to.path, query: {}, hash: to.hash }
}

// function removeHash(to: RouteLocationNormalized) {
//   if (to.hash) return { path: to.path, query: to.query, hash: '' }
// }

export default router
